import './NewsGrid.scss';
import template from './NewsGrid.vhtml';
import EventBus from '../eventBus';

export default {
	name: 'NewsGrid',
	template: template,
	props: {
		items: {
			type: Array,
			default: null,
		},
		currentPage: {
			type: Number,
			default: 1,
		},
		pagination: {
			type: Number,
			default: 0,
		},
	},
	data: () => ({}),
	computed: {},
	methods: {
		getPage(page) {
			EventBus.$emit('page-change', page);
		},
		getActiveClass(page) {
			return this.currentPage == page ? 'pagination__item--active' : '';
		},
	},
	mounted() {},
};
